import { createSelectorCreator, weakMapMemoize } from 'reselect';

/**
 *
 * KU
 *
 * @returns a memoized selector with an "infinite" cache
 *
 * https://reselect.js.org/api/weakMapMemoize#using-weakmapmemoize-with-createselectorcreator
 */
export const createMemoizedSelector = createSelectorCreator({
  memoize: weakMapMemoize,
  argsMemoize: weakMapMemoize,
});
